/* @ngInject */
function dateFilter ($filter) {
  return function (date, locale) {
    switch (locale) {
      case 'EN-US':
        return $filter('date')(date, 'MM/dd/yyyy')
      case 'PT-BR':
      case 'ES-ES':
      default:
        return $filter('date')(date, 'dd/MM/yyyy')
    }
  }
}

export { dateFilter }
